/* eslint-disable prettier/prettier */
export default {
  methods: {
    test() {
      return "testingbesting";
    },
  },
};

